import fetch from '@/utils/fetch';
import axios from 'axios';

export function getOssToken(path = '') {
  return fetch({
    url: '/api/v1/oss/token',
    method: 'post',
    data: { dir: path }
  })
}


export function uploadFile(responseData, file, filename) {
  let formData = new FormData();
  formData.append('key', filename);
  formData.append('success_action_status', 200);
  formData.append('policy', responseData.policy);
  formData.append('OSSAccessKeyId', responseData.accessid);
  formData.append('signature', responseData.signature);
  formData.append('callbackbody', responseData.callback);
  formData.append('file', file);

  return axios.post(responseData.host, formData);
}


// 生成指定二维码
export function getWxaQrCode(scene) {
  return fetch({
    url: '/api/v1/wxa/code',
    method: 'post',
    data: {
      page: 'packageShop/pages/shop/shop',
      scene: scene + ''
    }
  })
}
